module.exports = __webpack_public_path__ + "static/media/visit_bottom_photo.dcacbe7e.jpg";